import base from '@/api/base.js'; // 导入接口域名列表
import api from '@/api/index.js'; 

const art = (function(){
    return {
        ossurl: base.ossurl,

        formatTime: function (date, type) {
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            let day = date.getDate()

            let hour = date.getHours()
            let minute = date.getMinutes()
            let second = date.getSeconds()

            switch (type) {
            case "YYYY-MM-DD":
                return [year, month, day].map(formatNumber).join('-');
            case "YYYY-MM-DD hh:mm":
                return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute].map(formatNumber).join(':');
            default:
                return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':');
            }

            function formatNumber(n) {
                n = n.toString()
                return n[1] ? n : '0' + n
            }
        },

        /*oss方法压缩图片
		 * maxw: 允许最大宽度， maxh:允许最大高度 （满足一个即可）
		 */
		addOssResize: function(url, maxw, maxh) {
			if (!url) {return '';}
			if( this.isBlosUrl(url) ){return url;} //二进制url
			if (!maxw && !maxh) {return url;}
			var newurl = '';
			var reg = /(\/resize,m_mfit)+((,w_\d+)|(,h_\d+)){1,2}/gi;
			//已经有压缩
			if (url.indexOf('/resize,m_mfit,') > 0) {
				//只有最大宽度maxw
				if (maxw && !maxh) {
					newurl = url.replace(reg, '/resize,m_mfit,w_' + maxw);
				}
				//只有最大高度maxh
				if (!maxw && maxh) {
					newurl = url.replace(reg, '/resize,m_mfit,h_' + maxh);
				}
				//maxw、maxh都有
				if (maxw && maxh) {
					newurl = url.replace(reg, '/resize,m_mfit,w_' + maxw + ',h_' + maxh);
				}
			}
			//没有压缩
			else {
				if (url.indexOf('?x-oss-process=image/') > 0) {
					newurl = url + '/resize,m_mfit';
				}else {
					if( url.indexOf('?x-oss-process=') > 0 ){
						newurl = url + '&x-oss-process=image/resize,m_mfit';
					}else{
						newurl = url + '?x-oss-process=image/resize,m_mfit';
					}
				}
				//有maxw
				if (maxw) {
					newurl += ',w_' + maxw;
				}
				//有maxh
				if (maxh) {
					newurl += ',h_' + maxh;
				}
			}
			return this.addOssurlHeader(newurl);
		},

		//处理oss地址,有就不加头部
		addOssurlHeader: function(url) {
            if(!url) return '';
            var that = this;
            var i1 = url.indexOf('http');  //http开头就不加，（包括直播回放地址myqcloud.com/）
            var i2 = url.indexOf('data:image/'); //base64图片不加
            if( i1==0 || i2==0 ){ 
                return url;
            }else{
                var newurl = that.removeOssurlHeader(url);
                return that.ossurl + newurl;
            }
		},
        //去掉oss地址前缀
        removeOssurlHeader: function (url) {
            if(!url) return;
            var i = url.indexOf('-bucket.oss-cn-beijing.aliyuncs.com/'); //第一次出现的位置
            if(i>0) url = url.substr(i+36);
            return url;
        },

        //获取oss视频的封面图
		getOssVideoSnapshot: function(url, t, f, w, h) {
			var that = this;
			if (!url) {return '';} //视频地址
			if (!t) {return url;}  //时刻（截取什么时刻的屏）
			if (!f) {f = 'png';}   //图片格式
			if (!w) {w = 0;}       //图片宽
			if (!h) {h = 0;}       //图片高
			var k = '2a80538793e14.mp4?x-oss-process=video/snapshot,t_10,f_jpg,h_0,w_1000,m_fast';
			var reg = /(\/snapshot,t_\d+)(,f_(jpg|png))((,w_\d+)|(,h_\d+)){1,2}(,m_fast){0,1}/gi;
			var newurl = ';'
			//已经有截幁
			if (url.indexOf('/snapshot,t_') > 0) {
				newurl = url.replace(reg, '/snapshot,t_' + t + ',f_' + f + ',w_' + w + ',h_' + h + ',m_fast');
			} else {
				if (url.indexOf('?x-oss-process=video') > 0) {
					newurl = url + '/snapshot,t_' + t + ',f_' + f + ',w_' + w + ',h_' + h + ',m_fast';
				} else {
					newurl = url + '?x-oss-process=video/snapshot,t_' + t + ',f_' + f + ',w_' + w + ',h_' + h + ',m_fast';
				}
			}
			return that.addOssurlHeader(newurl);
		},

        //检查url地址是图片、视频、音频
		checkSourceUrlType: function(url) {
			if (!url) return false;
			var url = url.toLowerCase();
			var len = url.lastIndexOf('.');
			var typestr = url.slice(len + 1);
			if (typestr == 'jpg' || typestr == 'jpeg' || typestr == 'png' || typestr == 'gig' || typestr == 'bmp') {
				return 'image';
			} else if (typestr == 'mp3') {
				return 'audio';
			} else if (typestr == 'mp4' || typestr == 'ogg' || typestr == 'avi' || typestr == 'flv') {
				return 'video';
			} else {
				return false;
			}
		},

        /*自定义运算，实现加减乘除运算，确保不丢失精度
		 * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）*/
		operation: function(a, b, digits, op) {
			//判断obj是否为一个整数
			function isInteger(obj) { return Math.floor(obj) === obj }
			/*
			 * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
			 * @param floatNum {number} 小数
			 * @return {object} 如：{times:100, num: 314}
			 */
			function toInteger(floatNum) {
			    var ret = {times: 1, num: 0}
			    if (isInteger(floatNum)) {
			        ret.num = floatNum
			        return ret
			    }
			    var strfi  = floatNum + ''
			    var dotPos = strfi.indexOf('.')
			    var len    = strfi.substr(dotPos+1).length
			    var times  = Math.pow(10, len)
			    var intNum = parseInt(floatNum * times + 0.5, 10)
			    ret.times  = times
			    ret.num    = intNum
			    return ret
			}
		    var o1 = toInteger(a)
		    var o2 = toInteger(b)
		    var n1 = o1.num
		    var n2 = o2.num
		    var t1 = o1.times
		    var t2 = o2.times
		    var max = t1 > t2 ? t1 : t2
		    var result = null
		    switch (op) {
		        case 'add':
		            if (t1 === t2) { // 两个小数位数相同
		                result = n1 + n2
		            } else if (t1 > t2) { // o1 小数位 大于 o2
		                result = n1 + n2 * (t1 / t2)
		            } else { // o1 小数位 小于 o2
		                result = n1 * (t2 / t1) + n2
		            }
		            return result / max
		        case 'subtract':
		            if (t1 === t2) {
		                result = n1 - n2
		            } else if (t1 > t2) {
		                result = n1 - n2 * (t1 / t2)
		            } else {
		                result = n1 * (t2 / t1) - n2
		            }
		            return result / max
		        case 'multiply':
		            result = (n1 * n2) / (t1 * t2)
		            return result
		        case 'divide':
		            result = (n1 / n2) * (t2 / t1)
		            return result
		    }
		},
		
		//加
		add: function(a, b, digits) {
		   //return this.operation(a, b, digits, 'add')
			var arg1 = a;
			var arg2 = b;
			var r1,r2,m;
			try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
			try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
			m=Math.pow(10,Math.max(r1,r2))
			return (Math.round(arg1*m)+Math.round(arg2*m))/m
		},
		//减
		subtract: function(a, b, digits) {
		    return this.operation(a, b, digits, 'subtract')
		},
		//乘
		multiply: function(num1,num2) {
		    //return this.operation(a, b, digits, 'multiply')
			if(!num1 && num1!==0) return '';
			if(!num2 && num2!==0) return num1;
			var m=0, s1=num1.toString(), s2=num2.toString(); 
			try{m+=s1.split(".")[1].length}catch(e){};
			try{m+=s2.split(".")[1].length}catch(e){};
			return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m);
		},
		//除
		divide: function(a, b, digits) {
		    return this.operation(a, b, digits, 'divide')
		},
		
		//编码
		encode: function(str){
			return encodeURIComponent(str);
		},
		//编码
		decode: function(str){
			return decodeURIComponent(decodeURIComponent(str));
		},
		
		//保留len位小数点，（没有小数点默认不加0） num:原数字 len:要保留的位数
		toFixed: function(num,len){
			len = isNaN(len) ? 0 : len;
			var bei = Math.pow(10,len); //10的len次方
			return this.divide( Math.round(this.multiply(num,bei)), bei);
        },

        //建立一個可存取到該file的url
		getObjectURL: function(file) {
			var url = null;
			if (window.createObjectURL != undefined) {
				url = window.createObjectURL(file);
			} else if (window.URL != undefined) {
				url = window.URL.createObjectURL(file);
			} else if (window.webkitURL != undefined) {
				url = window.webkitURL.createObjectURL(file);
			}
			return url;
		},

        //图片 base64 转换成=> file 
		dataURItoFile: function(dataURI, fileName) {
			var byteString = atob(dataURI.split(',')[1]);
			var ab = new ArrayBuffer(byteString.length);
			var ia = new Uint8Array(ab);
			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}
			//return new Blob([ab], { type: 'image/jpeg' }); 
			return new File([ia], fileName, {
				type: 'image/jpeg',
				lastModified: Date.now()
			})
		},

        //判断是否是二进制URL
		isBlosUrl: function(url){
			var urlHead = 'blob:'+location.protocol+'//'+location.host; //二进制地址开头
			var reg = new RegExp('^('+urlHead+')', 'i');
			return reg.test(url);
		},

        /* 上传资源到oss服务器
		 * fileObj：file对象    input.files[0]得到
		 * lei：           image-图片， video-视频
		 * folder：  上传oss新建的文件夹名称
		 * suc:    成功回调
		 * err:    失败回调
		 * onlypng: 是否图片格式jpg强行改成png
		 * */
        UpFileToOss: function (file, lei, folder, suc, err, onlypng, progress1,fullSrc) {
            var that = this;
            var vm = this;
            if (!file) { return; }
            var storeAs = clacName(file);
            getOssUploadGetSecurityToken(function(d){
                upOss(d);
            });
            //计算文件名
            function clacName(file){
                var val = file.name;//filename
                var suffix = val.substr(val.lastIndexOf('.')); //获取后缀（如： .png）
                suffix = suffix.toLowerCase();
                suffix = suffix.replace(/.jpeg/gi, ".jpg");
                if (onlypng == true) {
                    suffix = suffix.replace(/.jpg/gi, ".png");
                }
                var storeAs = folder + suffix;
                return storeAs;
            }
            function upOss(d){
                var client = new OSS.Wrapper({
                    //后台给的
                    region: "oss-cn-beijing",
                    secure: true,
                    accessKeyId: d.accessKeyId,
                    accessKeySecret: d.accessKeySecret,
                    bucket: d.bucketName,
                    stsToken: d.securityToken,
                    //原来的
                    // region: "oss-cn-beijing",
                    // secure: true,
                    // accessKeyId: "X8T0w0VNj6ZrMej4",
                    // accessKeySecret: "VziKfO9oXMINPnvzaJNcgcvE0mYWCq",
                    // bucket: "artapp-dev-bucket"
                });
                client.options.endpoint.protocol = "https:";
                let storeAs= d.object;
                client.multipartUpload(storeAs, file).then(function (res) {
                    suc(fullSrc ? d.host+'/'+storeAs : storeAs);
                }).catch(function (res) {
                    err(res);
                });
            }
            function getOssUploadGetSecurityToken(callback){
                let webUploadSign = sessionStorage.getItem('instWebUploadSign');
                let needUpdate = false;
                if(webUploadSign){
                    webUploadSign = JSON.parse(webUploadSign);
                    let expiration = webUploadSign.expiration;
                    let now = Date.parse(new Date());
                    if(expiration<now + 3000) needUpdate = true;
                }
                else{
                    needUpdate = true;
                }
                if(needUpdate){
                    api.pub.ossUploadGetSecurityTokenWithSign({object:storeAs})
                    .then((res) => {
                        var webUploadSign = res.body.webUploadSign;
                        //sessionStorage.setItem('instWebUploadSign',JSON.stringify(webUploadSign))
                        callback(webUploadSign);
                    })
                    .catch((res) => {});
                }
                else{
                    callback(webUploadSign);
                }
            }
        },
        //视频封面图转成正常图片
        getNewImgUrl: function (url, dir, suc, err) {
            //把图片转成base64，然后上传oss,得到新的地址
            var that = this;
            var img = url; //oss的图片转base64报跨域错，可能需要配置
            that.getBase64Image(img, function (base64) {
                var file = that.dataURItoFile(base64, 'xxx.png');
                that.UpFileToOss(file, "image", dir, function (url) {
                    suc(url);
                }, function (res) {
                    console.log(res,'上传失败');
                    err(res);
                });
            });
        },
        //图片地址变成base64
        getBase64Image: function (url, callback) {
            let that = this;
            var img = new Image();
            img.setAttribute("crossOrigin", 'Anonymous');
            img.setAttribute("crossOrigin", '*');
            img.src = url;
            img.onload = function () {
                try {
                    var canvas = document.getElementById("mycanvasForBase64Image");//获取canvas
                    if (!canvas) {
                        canvas = document.createElement("canvas");
                        canvas.id = 'mycanvasForBase64Image';
                        canvas.style.display = 'none';
                        document.body.appendChild(canvas);
                    }
                    canvas.width = img.width;
                    canvas.height = img.height;
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, img.width, img.height);
                    var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
                    var dataURL = canvas.toDataURL("image/png", 1);
                    callback(dataURL);
                } catch (err) {
                    that.getBase64Image(switchHttps(url), callback);
                }
            }
            function switchHttps(url) {
                var str = url.toLowerCase();
                if (str.slice(0, 4) === 'http') {
                    if (str.slice(4, 5) === 's') {
                        return str.replace('https://', 'http://');
                    } else {
                        return str.replace('http://', 'https://');
                    }
                }
            }
        },
    }
})()
    
export default art;